import { styled as StyledMui } from "@mui/system";
import { Box, Button, TextField, Typography } from "@mui/material";
import { laptopMQL } from "../../utils/constant";

export const SearchButton = StyledMui(Button)(() => ({
  fontSize: "2rem",
  padding: "1rem 4.5rem",
  width: "18rem",
  backgroundColor: "#CF2030",
  color: "#FFFFFF",
  overflow: "hidden",
  textOverflow: "ellipsis",
  border: "1px solid #cf2030",
  "&:hover": {
    boxShadow: "none !important",
    backgroundColor: "#CF2030 !important",
  },
  [laptopMQL]: {
    lineHeight: "normal",
    width: "18rem",
  },
}));

export const ResetButton = StyledMui(Button)(() => ({
  fontSize: "2rem",
  padding: "1rem 4.5rem",
  width: "18rem",
  backgroundColor: "#FFFFFF",
  color: "#cf2030",
  overflow: "hidden",
  textOverflow: "ellipsis",
  border: "1px solid #cf2030",
  "&:hover": {
    boxShadow: "none !important",
    backgroundColor: "#FFFFFF",
  },
  [laptopMQL]: {
    lineHeight: "normal",
  },
}));

export const MyConnectionsContainer = StyledMui(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
}));

export const MyConnectionsSearchContainer = StyledMui(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  rowGap: "0.5rem",
  padding: "5.5rem 0 4.5rem 0",
  width: "110rem",
  [laptopMQL]: { width: "100rem", padding: "2.8rem 0 0.8rem 0" },
  "@media only screen and (max-width: 830px)": {
    width: "auto",
    maxWidth: "90rem",
  },
}));

export const MyConnectionsSearchBox = StyledMui(Box)(() => ({
  display: "flex",
  columnGap: "2rem",
  justifyContent: "space-around",
  "@media only screen and (max-width: 830px)": {
    flexWrap: "wrap",
    rowGap: "1rem",
    marginBottom: "2rem",
  },
}));

export const MyConnectionsSearchFieldBox = StyledMui(Box)(() => ({
  width: "59rem",
  "@media only screen and (max-width: 830px)": {
    width: "90%",
  },
}));

export const MyConnectionsSearchField = StyledMui(TextField)(() => ({
  width: "100%",
  backgroundColor: "#FFFFFF",
  borderRadius: "4px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px !important",
    border: "1px solid #D9D9D9 !important",
    borderRadius: "4px",
    boxShadow: "5px 5px 5px 5px rgba(0, 0, 0, 0.07) !important",
  },
  ".MuiInputBase-input": { color: "#64666A" },
  [laptopMQL]: {
    ".MuiInputBase-input": {
      padding: "1rem 1.4rem 1rem 0.5rem",
    },
    ".search-ico": {
      height: "2.2rem",
    },
  },
}));

export const MyConnectionsSearchMinCharError = StyledMui(Typography)(
  ({ theme, searchFieldError }) => ({
    color: theme.bniRed.main,
    textAlign: theme.direction === "rtl" ? "right" : "left",
    padding: "1rem 2.5rem 0rem 0.5rem",
    visibility: String(searchFieldError) === "true" ? "visible" : "hidden",
  })
);

export const MyConnectionsSearchActionsBox = StyledMui(Box)(() => ({
  display: "flex",
  columnGap: "2rem",
  "@media only screen and (min-width: 426px) and (max-width: 830px)": {
    width: "90%",
    justifyContent: "flex-end",
    maxWidth: "480px",
  },
}));

export const BniLoaderBox = StyledMui(Box)(() => ({
  gridColumn: "1/-1",
}));
